module.exports = __webpack_public_path__ + "static/media/A2888-rules-and-regulation-17122020.dd583563.pdf";